import React from "react";
import VehicleCard from "../../../vehicle-card/VehicleCard";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import { colors } from "../../../../../../../themes/Colors";

const EnatisReport = ({ data }) => {
  return (
    <div
      style={{
        width: "100%",
        // marginTop: 10,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          // paddingTop: 20,
          // paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 120,
          marginTop: 10,
        }}
      >
        <VehicleCard
          width={"100%"}
          // onManageClick={
          //   width > 899
          //     ? () => setManageVehicle(vehicle)
          //     : () => setVehicleManageView(vehicle)
          // }
          // type={type}
          licenceNr={data ? data.liscenseNumber : "loading"}
          // engineNr={vehicle.engineNumber}
          make={data ? data.make : "loading"}
          series={data ? data.series : "loading"}
          expireDate={"200 days"}
          // index={index + 1}
        />
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 50,
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          marginTop: 20,
          borderColor: "#00000050",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 16,
          color: "#00000080",
        }}
      >
        ENATIS REPORT
      </div>
      <div
        style={{
          position: "fixed",
          bottom: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <BaseButtons
          label={"BUTTON"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"90%"}
        />
      </div>
    </div>
  );
};

export default EnatisReport;
